import { render, staticRenderFns } from "./main_live.vue?vue&type=template&id=055afda3&scoped=true&"
import script from "./main_live.vue?vue&type=script&lang=js&"
export * from "./main_live.vue?vue&type=script&lang=js&"
import style0 from "./main_live.vue?vue&type=style&index=0&id=055afda3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055afda3",
  null
  
)

export default component.exports